
export default [
    {
        path: '/myshop',
        component: resolve => require(['../../views/shop/MyShop.vue'], resolve),
        meta: { title: '我的店铺' }
    },
    {
        path: '/shopinfo',
        component: resolve => require(['../../views/shop/ShopInfo.vue'], resolve),
        meta: { title: '店铺信息' }
    },
    {
        path: '/shopsetting',
        component: resolve => require(['../../views/shop/ShopSetting.vue'], resolve),
        meta: { title: '店铺设置' }
    },
    {
        path: '/shopsmart',
        component: resolve => require(['../../views/shop/SmartShop.vue'], resolve),
        meta: { title: '智能店铺' }
    },
]



// WEBPACK FOOTER //
// ./src/TASMini/router/modules/shop.js